import {
  Avatar,
  Box,
  Typography,
  useTheme,
  Select,
  MenuItem,
} from "@mui/material";
import { tokens } from "../theme";
import React, { useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { useState } from "react";
import Pagination from "@mui/material/Pagination";
import { ACTIVITY_PERIODS } from "../constants/Constant";

const UserActivityPayoutDates = ({
  data,
  ondateRangeChange: onDateRangeChange,
  totalNoOfPages,
  onPageChange,
  onItemClicked
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [earmarkActivityDetails, setearmarkActivityDetails] = useState([]);
  const [dateRange, setDateRange] = useState(ACTIVITY_PERIODS.THREE_MONTHS);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const pageCount = totalNoOfPages ? totalNoOfPages : 1;

  const handleDateRangeChange = (event) => {
    setDateRange(event.target.value);
    onDateRangeChange(event.target.value);
  };

  useEffect(() => {
    if (data) {
      setearmarkActivityDetails(data);
    }
  }, [data]);

  const handlePageChange = (value) => {
    setCurrentPage(value);
    onPageChange(value - 1); // Index starts from 0 for data array
  };

  const getInitials = (name) => {
    // check if name is null or empty
    if (!name) return "";

    const words = name.split(" ");
    const initials = words
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
    return initials;
  };

  return (
    <Box sx={{ width: "100%" }}>
      {earmarkActivityDetails.length > 0 ? (
        <Grid
          container
          direction={"column"}
          mt={3}
          p={3}
          xs={12}
          mb={20}
          sx={{
            background: colors.grey[900],
            borderRadius: "12px",
          }}
        >
          <Grid container fontSize={20} fontWeight={700}>

            {/* Activity Header */}
            <Grid item xs={6}>
              Activity
            </Grid>

            {/* Time Period Dropdown */}
            <Grid item xs={6}>
              <Box display="flex" justifyContent="flex-end">
                <Select
                  value={dateRange}
                  onChange={handleDateRangeChange}
                  displayEmpty
                  inputProps={{
                    "aria-label": "Select a time period",
                  }}
                  sx={{
                    height: "30px",
                    "& .MuiSelect-select": {
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                    },
                  }}
                  // IconComponent={"../../assets/common/Arrow-down.svg"}
                >
                  {/* Create a menu item for each activity period defined in constants */}
                  {Object.values(ACTIVITY_PERIODS).map((period) => (
                    <MenuItem key={period} value={period}>
                      {period}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Grid>
          </Grid>

          {earmarkActivityDetails.map((row) => (
            
            // Activity Row //
            <Grid item key={row.id} xs={12}>
              <Grid
                container
                direction={"row"}
                mt={2}
                spacing={2}
                alignItems={"center"}
              >
                {/* Avatar */}
                <Grid item xl={0.5} lg={0.65} md={1} sm={1.5}>
                  <Avatar
                    sx={{
                      bgcolor: colors.grey[900],
                      color: colors.grey[100],
                      border: "1px solid #888888",
                    }}
                  >
                    {getInitials(row.modifiedBy)}
                  </Avatar>
                </Grid>

                {/* Content */}
                <Grid item xl={9.5} lg={9.35} md={9} sm={8.5} sx={{ flexGrow:"1 !important" }}>
                  <Typography>
                    <Box sx={{ width:"100%" }}>
                      <span style={{ fontWeight: 600 }}>{row.modifiedBy}</span>
                      <span> </span>
                      <span>{row.action}</span>
                      <span> </span>
                      <span style={{ fontWeight: 600 }}>{row.title}</span>
                      <span>{` `}</span>
                      <span style={{ fontWeight: 600 }}>{row.description}</span>
                    </Box>
                  </Typography>


                  {row.action && (
                    <Grid item sx={{ overflowY: "auto" }}>
                      <Typography>
                        <span style={{ fontWeight: 600 }}>Action: </span>
                        {row.action}
                      </Typography>
                    </Grid>
                  )}
                  
                    {row.noOfChanges && (
                      <Grid item sx={{ overflowY: "auto" }}>
                        <Box onClick={() => onItemClicked(row)}>
                        <Typography>
                          <span
                            style={{
                              fontWeight: 600,
                              color: colors.primary[100],
                            }}
                          >
                            {row.noOfChanges + " Items"}{" "}
                          </span>
                        </Typography>
                        </Box>
                      </Grid>
                    )}
                 
                </Grid>

                {/* Date Time */}
                <Grid
                  item
                  xl={2}
                  lg={2}
                  md={2}
                  sm={2}
                  sx={
                    {
                      // position: 'relative',
                      // right: '-360%',
                      // color: colors.grey[300],
                    }
                  }
                >
                
                     {row.modifiedOn}
                    </Grid>

                </Grid>
              </Grid>
            // Activity Row //
          ))}

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ marginTop: 3 }}
          >
            <Pagination
              count={pageCount}
              page={currentPage}
              onChange={(event, value) => handlePageChange(value)}
            />
          </Box>

          <Typography sx={{ marginTop: 2 }}>
            <span>Jump to page: </span>
            <select
              value={currentPage}
              onChange={(event) => handlePageChange(Number(event.target.value))}
              sx={{ marginRight: 2 }}
            >
              {[...Array(pageCount)].map((_, index) => (
                <option key={index} value={index + 1}>
                  {index + 1}
                </option>
              ))}
            </select>
          </Typography>
        </Grid>
      ) : (
        ""
      )}
    </Box>
  );
};

export default UserActivityPayoutDates;
